import React from 'react';
import { Link } from 'react-router-dom';
import Icon from './AppIcon';

const GlobalFooter = ({ className = '' }) => {
  return (
    <footer className={`bg-card border-t border-border mt-auto ${className}`}>
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6 lg:px-8 py-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-center">
          {/* Left: Copyright Section */}
          <div className="flex items-center justify-center md:justify-start gap-2 text-sm text-muted-foreground">
            <Icon name="Copyright" size={14} className="text-muted-foreground" />
            <span className="font-medium">
              2025 Decks N Dollars LLP. All Rights Reserved.
            </span>
          </div>

          {/* Center: Website Name/Brand */}
          <div className="flex items-center justify-center">
            <Link to="/" className="text-lg font-bold text-foreground hover:text-primary transition-colors duration-200">
              DecX AI
            </Link>
          </div>

          {/* Right: Legal Links */}
          <div className="flex items-center justify-center md:justify-end gap-1">
            <Link
              to="https://decx.ai/#/terms"
              className="text-sm text-muted-foreground hover:text-primary transition-colors duration-200 px-3 py-1 rounded-md hover:bg-muted/50"
            >
              Terms
            </Link>
            <span className="text-muted-foreground/50">|</span>
            <Link
              to="https://decx.ai/#/privacy"
              className="text-sm text-muted-foreground hover:text-primary transition-colors duration-200 px-3 py-1 rounded-md hover:bg-muted/50"
            >
              Privacy Policy
            </Link>
            <span className="text-muted-foreground/50">|</span>
            <Link
              to="/contact-support"
              className="text-sm text-muted-foreground hover:text-primary transition-colors duration-200 px-3 py-1 rounded-md hover:bg-muted/50"
            >
              Contact Support
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default GlobalFooter;